import { useEffect, useState } from 'react';
import api from '../lib/api';
// design/035 — "Email members when this is published" for course and
// practice editors. Once the email has gone out it's shown as sent (it is
// only ever sent once, on first publish).
export default function AnnounceField({ announce, announcedAt, onChange, kind = 'course' }) {
  if (announcedAt) {
    return (
      <div className="form-field">
        <label>Announcement email</label>
        <div style={{ color: 'var(--muted)', fontSize: '0.875rem' }}>
          ✉️ Members were emailed about this {kind} on {new Date(announcedAt).toLocaleDateString()}.
        </div>
      </div>
    );
  }
  return (
    <div className="form-field">
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 500, cursor: 'pointer' }}>
        <input type="checkbox" checked={announce !== false} onChange={(e) => onChange(e.target.checked)} />
        Email members when this {kind} is published
      </label>
      <div style={{ color: 'var(--muted)', fontSize: '0.8rem', marginTop: 4 }}>
        Sent once, about 15 minutes after it's first published, with a link to it on the website.
        Members who unsubscribed don't get it.
      </div>
    </div>
  );
}

/**
 * Events and groups: same setting, loaded and saved on its own (saves as soon
 * as it's changed). Private events are never announced.
 */
export function AnnounceToggle({ kind, id, isPrivate = false }) {
  const [st, setSt] = useState(null);
  useEffect(() => {
    let alive = true;
    api.announceState(kind, id).then((r) => { if (alive) setSt(r); }).catch(() => {});
    return () => { alive = false; };
  }, [kind, id]);
  if (!st) return null;
  if (isPrivate && !st.announcedAt) {
    return (
      <div className="form-field">
        <label>Announcement email</label>
        <div style={{ color: 'var(--muted)', fontSize: '0.875rem' }}>Private {kind}s aren't announced to members.</div>
      </div>
    );
  }
  const change = async (v) => {
    const prev = st;
    setSt({ ...st, announce: v });
    try { setSt(await api.setAnnounce(kind, id, v)); }
    catch (e) { setSt(prev); alert(e?.data?.message || e.message); }
  };
  return <AnnounceField kind={kind} announce={st.announce} announcedAt={st.announcedAt} onChange={change} />;
}
